<template>
  <div class="competition-container">
    <section class="competition-wrapper text-left">
      <div class="d-flex justify-content-between">
        <h2 class="name">{{ competition.name }}</h2>
        <font-awesome-icon
          :icon="
            `${
              this.fastFavouriteColorChange === true
                ? 'fa-solid fa-bookmark'
                : this.fastFavouriteColorChange === false
                ? 'fa-regular fa-bookmark'
                : competitionIsFavourite
                ? 'fa-solid fa-bookmark'
                : 'fa-regular fa-bookmark'
            }`
          "
          class="icon"
          @click="toggleFavorites(competition._id)"
        />
      </div>
      <p class="application-type my-3">{{ getAppType() }}</p>
      <p class="description mb-4">{{ competition.text }}</p>

      <p class="related-definitions" v-if="relatedDefinitions.length > 0">
        <b>Kapcsolódó fogalmak:</b>
        <b-button
          class="related-defs-btn"
          variant="secondary"
          @click="handleRelDefBtn(r.slug)"
          v-for="r in relatedDefinitions"
          :key="r.slug"
        >
          {{ r.name }}
        </b-button>
      </p>

      <div v-if="competition.type === 'APPLICATION'" class="details-container">
        <p
          v-show="
            competition.fundId.applicationData.applicationMin || competition.fundId.applicationData.applicationMin === 0
          "
          class="mt-3"
        >
          <b>Támogatási összeg minimuma:</b>
          {{ numberWithDots(competition.fundId.applicationData.applicationMin) + ' HUF' }}
        </p>
        <p
          v-show="
            competition.fundId.applicationData.applicationMax || competition.fundId.applicationData.applicationMax === 0
          "
          class="mt-3"
        >
          <b>Támogatási összeg maximuma:</b>
          {{ numberWithDots(competition.fundId.applicationData.applicationMax) + ' HUF' }}
        </p>
        <p><b>Előminősítés:</b> {{ competition.fundId.preQualification.isActive ? 'Van' : 'Nincs' }}</p>
        <p v-if="competition.fundId.preQualification && !fieldIsEmpty(competition.fundId.preQualification.startDate)">
          <b>Előminősítés kezdete:</b> {{ formatDate(competition.fundId.preQualification.startDate) }}
        </p>
        <p
          v-if="
            competition.fundId.preQualification.endDate && !fieldIsEmpty(competition.fundId.preQualification.endDate)
          "
        >
          <b>Előminősítés vége:</b> {{ formatDate(competition.fundId.preQualification.endDate) }}
        </p>
      </div>
      <div v-if="competition.type === 'CREDIT'" class="details-container">
        <p
          v-show="
            competition.fundId.creditDuration.repaymentMin || competition.fundId.creditDuration.repaymentMin === 0
          "
          class="mt-3"
        >
          <b>Futamidő minimuma:</b>
          {{
            competition.fundId.creditDuration.repaymentMin +
              ' ' +
              RepaymentType[competition.fundId.creditDuration.repaymentType]
          }}
        </p>
        <p
          v-show="
            (competition.fundId.creditData.creditMin || competition.fundId.creditData.creditMin === 0) &&
              competition.fundId.creditData.creditCurrency
          "
          class="mt-3"
        >
          <b>Hitelösszeg minimuma:</b>
          {{ numberWithDots(competition.fundId.creditData.creditMin) }}
          {{ competition.fundId.creditData.creditCurrency }}
        </p>
        <p
          v-show="
            (competition.fundId.creditData.creditMax || competition.fundId.creditData.creditMax === 0) &&
              competition.fundId.creditData.creditCurrency
          "
          class="mt-3"
        >
          <b>Hitelösszeg maximuma:</b>
          {{ numberWithDots(competition.fundId.creditData.creditMax) }}
          {{ competition.fundId.creditData.creditCurrency }}
        </p>
        <p v-show="competition.fundId.interest.interest" class="mt-3">
          <b>Kamat:</b> {{ competition.fundId.interest.interest }}
        </p>
      </div>
      <div v-if="competition.type === 'CAPITAL_PRODUCT'" class="details-container">
        <p
          v-show="
            competition.fundId.capitalProductData.financeMin || competition.fundId.capitalProductData.financeMin === 0
          "
          class="mt-3"
        >
          <b>Finanszírozás összegének minimuma:</b>
          {{ numberWithDots(competition.fundId.capitalProductData.financeMin) + ' HUF' }}
        </p>
        <p
          v-show="
            competition.fundId.capitalProductData.financeMax || competition.fundId.capitalProductData.financeMax === 0
          "
          class="mt-3"
        >
          <b>Finanszírozás összegének maximuma:</b>
          {{ numberWithDots(competition.fundId.capitalProductData.financeMax) + ' HUF' }}
        </p>
        <p
          v-show="
            (competition.fundId.capitalProductData.investmentTermMin ||
              competition.fundId.capitalProductData.investmentTermMin === 0) &&
              (competition.fundId.capitalProductData.investmentTermMax ||
                competition.fundId.capitalProductData.investmentTermMax === 0)
          "
          class="mt-3"
        >
          <b>Befektetés időtartama:</b> {{ competition.fundId.capitalProductData.investmentTermMin }} -
          {{ competition.fundId.capitalProductData.investmentTermMax }}
          {{ InvestmentTermType[competition.fundId.capitalProductData.investmentTermType] }}
        </p>
      </div>
      <div v-if="competition.type === 'COMBINED'" class="details-container">
        <p
          v-show="
            (competition.fundId.intensityDuration.intensityCredit ||
              competition.fundId.intensityDuration.intensityCredit === 0) &&
              (competition.fundId.intensityDuration.intensitySupportValue ||
                competition.fundId.intensityDuration.intensitySupportValue === 0)
          "
          class="mt-3"
        >
          <b>Hitel és vissza nem térítendő támogatás aránya:</b>
          {{ competition.fundId.intensityDuration.intensityCredit + '%' }} -
          {{ competition.fundId.intensityDuration.intensitySupportValue + '%' }}
        </p>

        <p
          v-show="
            competition.fundId.intensityDuration.repaymentMin || competition.fundId.intensityDuration.repaymentMin === 0
          "
          class="mt-3"
        >
          <b>Futamidő minimuma:</b>
          {{
            competition.fundId.intensityDuration.repaymentMin +
              ' ' +
              RepaymentType[competition.fundId.intensityDuration.repaymentType]
          }}
        </p>
        <p
          v-show="
            competition.fundId.intensityDuration.repaymentMax || competition.fundId.intensityDuration.repaymentMax === 0
          "
          class="mt-3"
        >
          <b>Futamidő maximuma:</b>
          {{
            competition.fundId.intensityDuration.repaymentMax +
              ' ' +
              RepaymentType[competition.fundId.intensityDuration.repaymentType]
          }}
        </p>
      </div>

      <div>
        <b-button class="more-info-btn col-12 col-sm-auto" @click="goToDetailsPage">További információ</b-button>

        <b-button
          class="col-12 col-sm-auto mt-3 mt-sm-0 ml-sm-3"
          variant="primary"
          @click="handleOfferLink(competition.link)"
          >Érdekel</b-button
        >
        <b-button
          class="col-12 col-sm-auto mt-3 mt-sm-0 ml-sm-3"
          v-if="competition.preQualification && competition.type === 'APPLICATION'"
          @click="handleOfferLink(competition.preQualificationLink)"
          >Előminősítési link</b-button
        >
      </div>
    </section>
  </div>
</template>
<script>
import { mapGetters } from 'vuex'
import { getReadableCompetitionType } from '../../../constants/competitionTypes'
import * as CompetitionApi from '../../../api/competition'
import { getRelatedDefinition } from '../../../api/knowledgebase'
import RepaymentType from '../../../enums/RepaymentType'
import InvestmentTermType from '../../../enums/InvestmentTermType'
import * as ImaginaryUserCompanyApi from '../../../api/imaginaryUserCompany'
import * as imaginaryCompanyApi from '../../../api/imaginaryCompany'

export default {
  name: 'FundMapFilteredCompetitions',
  data() {
    return {
      loading: true,
      matchingResults: null,
      relatedDefinitions: [],
      RepaymentType,
      InvestmentTermType,
      selectedCompanyId: '',
      imaginaryUserCompanies: [],
      fastFavouriteColorChange: null
    }
  },
  props: ['competition'],
  methods: {
    numberWithDots(number) {
      if (!this.fieldIsEmpty(number)) {
        return number.toString().replace(/\B(?=(\d{3})+(?!\d))/g, '.')
      }
    },
    handleOfferLink(link) {
      const win = window.open(link, '_blank')
      win.focus()
    },
    async toggleFavorites(competitionId) {
      if (this.competitionIsFavourite) {
        this.fastFavouriteColorChange = false
      } else {
        this.fastFavouriteColorChange = true
      }
      let favoriteCompetitionIds = []

      if (this.competitionIsFavourite) {
        if (this.selectedCompanyId.toString().length > 8) {
          favoriteCompetitionIds = this.imaginaryUserCompany.favoriteCompetitionIds.filter(
            favoriteCompetitionId => favoriteCompetitionId !== competitionId
          )
        } else {
          favoriteCompetitionIds = this.userCompany.favoriteCompetitionIds.filter(
            favoriteCompetitionId => favoriteCompetitionId !== competitionId
          )
        }
      } else {
        if (this.selectedCompanyId.toString().length > 8) {
          favoriteCompetitionIds = [...this.imaginaryUserCompany.favoriteCompetitionIds, competitionId]
        } else {
          favoriteCompetitionIds = [...this.userCompany.favoriteCompetitionIds, competitionId]
        }
      }

      if (this.fundMapCompany.imaginaryCompany) {
        await imaginaryCompanyApi.patchImaginaryUserCompanyById(this.imaginaryUserCompany._id, favoriteCompetitionIds)

        this.getImaginaryUserCompaniesByCompanyId(this.selectedCompanyId)
      } else {
        await this.$store.dispatch('patchUserCompany', {
          userCompanyId: this.userCompany.id,
          favoriteCompetitionIds
        })
        this.$store.dispatch('getUserCompanies', {})
      }
    },
    getAppType() {
      return getReadableCompetitionType(this.competition.type)
    },
    fieldIsEmpty: function(field) {
      return field === '' || field === null || field === undefined
    },
    formatDate: function(date) {
      var d = new Date(date),
        month = '' + (d.getMonth() + 1),
        day = '' + d.getDate(),
        year = d.getFullYear()

      if (month.length < 2) month = '0' + month
      if (day.length < 2) day = '0' + day

      return [year, month, day].join('.')
    },
    goToDetailsPage() {
      this.$router.push(`/fund-map/fund/${this.competition._id}`)
    },
    handleRelDefBtn(slug) {
      this.$router.push(`/knowledgebase/${slug}`, () => {})
    },
    async getImaginaryUserCompaniesByCompanyId(companyId) {
      try {
        this.imaginaryUserCompanies = await ImaginaryUserCompanyApi.getImaginaryUserCompanyById(companyId)
      } catch (e) {
        console.log(e)
      }
    }
  },
  computed: {
    ...mapGetters(['userCompanies', 'fundMapCompany', 'fundMapCompanyAttributes']),
    competitionIsFavourite() {
      if (!this.competition) {
        return false
      }

      let companyFound
      if (this.selectedCompanyId.toString().length > 8) {
        companyFound = this.imaginaryUserCompanies.find(
          company => company.imaginaryCompanyId === this.selectedCompanyId
        )
      } else {
        companyFound = this.userCompanies.find(company => company.companyId === this.selectedCompanyId)
      }

      if (!companyFound) {
        return false
      }

      return companyFound.favoriteCompetitionIds.includes(this.competition._id)
    },
    userCompany() {
      return this.userCompanies.find(company => company.companyId === this.selectedCompanyId)
    },
    imaginaryUserCompany() {
      return this.imaginaryUserCompanies.find(company => company.imaginaryCompanyId === this.selectedCompanyId)
    }
  },
  created: async function() {
    if (this.fundMapCompany.imaginaryCompany) {
      this.selectedCompanyId = this.fundMapCompany.imaginaryCompany.companyId
      this.getImaginaryUserCompaniesByCompanyId(this.selectedCompanyId)
    } else {
      this.selectedCompanyId = this.fundMapCompany.flaggerId
    }
    try {
      const competition = await CompetitionApi.getCompetitionWithDetails(this.competition._id)
      this.competition = competition

      if (
        this.competition.fundId.productData.relatedDefinitions &&
        this.competition.fundId.productData.relatedDefinitions.length > 0
      ) {
        let relatedDefinitionsP = []
        for (let d of this.competition.fundId.productData.relatedDefinitions) {
          relatedDefinitionsP.push(getRelatedDefinition(d))
        }
        let relatedDefinitionsQ = await Promise.allSettled(relatedDefinitionsP)
        this.relatedDefinitionsQ = relatedDefinitionsQ.filter(e => e.status === 'fulfilled')
        this.relatedDefinitions = relatedDefinitionsQ.map(e => e.value)
      }
    } catch (e) {
      console.log('Error happened during a getCompetition api call', e)
    }
  }
}
</script>
<style scoped>
.name {
  font-weight: 400;
  font-size: 18px;
  max-width: 800px;
  color: #00903c;
}
.icon {
  color: #ba3b46;
  cursor: pointer;
  font-size: 20px;
  margin-left: 20px;
}

.application-type {
  padding: 4px 8px;
  border-radius: 100px;
  font-weight: 500;
  font-size: 12px;
  color: #000;
  background-color: #dfe6e9;
  width: max-content;
}
.description {
  font-weight: 400;
  font-size: 16px;
}

.details-container {
  margin-bottom: 32px;
}
.details-container p {
  margin: 0;
  margin-bottom: 5px;
  padding: 0;
}

.competition-container {
  background-color: #f2f8fa;
  border-radius: 8px;
  padding: 25px;
}

.more-info-btn {
  background-color: #dfe6e9;
  color: #000;
  border: none;
}

.more-info-btn:hover,
.more-info-btn:active,
.more-info-btn:focus {
  background-color: #d0dadf !important;
  color: #000 !important;
  border: none;
}

.competition-wrapper {
  padding: 24px 36px;
}

@media only screen and (min-width: 992px) {
  .competition-wrapper {
    padding: 24px 72px;
  }
}

@media only screen and (min-width: 1200px) {
  .name {
    font-size: 20px;
  }
}

@media all and (max-width: 391px) {
  .competition-wrapper {
    padding: 16px 24px;
  }
}

.related-definitions {
  font-size: 75%;
}
.related-defs-btn {
  cursor: default;
  font-size: 75%;
  margin: 5px;
  padding: 5px;
  height: auto;
}
</style>
